import { post } from "services/network/endpoint"
import getOperation from "services/utils/operationExperience.js"
import { BFF } from "services/network/routes"
import * as ActionTypes from "services/state/action-types"

export function saveOperation(
  customer,
  stNumTelefone,
  idFunctionality,
  stAction,
  stIntegrity,
  stProtocol,
  stObs
) {
  return (dispatch, getState) => {
    const data = getOperation(
      customer,
      stNumTelefone,
      idFunctionality,
      stAction,
      stIntegrity,
      stProtocol,
      stObs
    )
    const config = {
      data,
      client: BFF
    }
    const request = post("experience", config)

    const isConsultantB2C = localStorage.getItem("isConsultant")
    const isConsultantB2BLogged = localStorage.getItem("isConsultantLoginB2B")

    if (isConsultantB2BLogged && isConsultantB2C) return

    dispatch({
      type: ActionTypes.BLANK_TYPE,
      payload: request
    })

    if (isConsultantB2C && !isConsultantB2BLogged)
      localStorage.setItem("isConsultantLoginB2B", "true")
  }
}



// WEBPACK FOOTER //
// ./src/services/state/experience/action.js